import '../../immer-init';
import React from 'react';
import { createRoot } from 'react-dom/client';
import '../../styles';
import './case-documents.scss';
import { popupFactory } from '../pop-up/index';
import { storeFactory } from '../pop-up/store';
import caseDocumentsRootReducer from '../../reducers/apps/case-documents-root.reducer';
import { Route, Switch } from 'react-router-dom';

import CaseDocumentsApp from './case-documents-component';

const { store, history } = storeFactory(caseDocumentsRootReducer);

const Popup = popupFactory({
  store,
  history
});

const documentsPopup = (
  <Popup>
    <Switch>
      <Route path="/" component={CaseDocumentsApp} />
    </Switch>
  </Popup>
);

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(documentsPopup);
